export default __webpack_public_path__ + "static/media/blured.70fa926a.png";